export default {
      id: "icon-angle-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "icons.svg#icon-angle",
      toString: function () {
        return this.url;
      }
    }